import React from 'react';
import { useDispatch } from 'react-redux';
import { useTimeoutToggle } from '@/hooks';
import { closeReactModal } from '@/actions';
import css from '../css/module/cell-content.css';
import ModalContent from './ModalContent';
import AceEditor from './AceEditor';
import { JSON, STRING, ARRAY, STRUCT } from '../util/ColumnType';

const CellContentModal = ({ value, columnType }) => {
  const dispatch = useDispatch();
  const [copied, toggleCopied] = useTimeoutToggle(3000);

  const handleCopyValue = () =>
    window.navigator.clipboard.writeText(value).then(toggleCopied).catch(alert);

  const handleCloseModal = () => dispatch(closeReactModal());

  const submitButtonText = copied ? 'Copied successfully' : 'Copy to clipboard';

  const looksLikeJson = (val) => {
    if (!val?.trim?.()?.length) {
      return false;
    }
    return val.trim().startsWith('[') || val.trim().startsWith('{');
  };

  const isJSON =
    [STRING, JSON, ARRAY, STRUCT].includes(columnType) && looksLikeJson(value);

  const useSmallModal = isJSON || (value?.length ?? 0) > 80;

  return (
    <ModalContent
      onClose={handleCloseModal}
      extraSmall={!useSmallModal}
      small={useSmallModal}
      header="Value"
      footer
      submitButtonText={submitButtonText}
      cancelButtonText="Close"
      onSubmit={handleCopyValue}
      headerStyle={{ minHeight: '65px', padding: '5px 40px' }}
      sectionFullHeight
    >
      <div className="h-100">
        {isJSON ? (
          <div className="position-relative w-100 h-100">
            <AceEditor
              isJSON
              initialJSON={value}
              readOnly
              maxLines={26}
              loadWithTimer
            />
          </div>
        ) : (
          <textarea
            style={{ resize: 'none', height: '100%' }}
            data-gramm="false"
            className={css.textArea}
            value={value ?? 'NULL'}
            readOnly
          />
        )}
      </div>
    </ModalContent>
  );
};

export default CellContentModal;
